import script from "./InstallPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstallPage.vue?vue&type=script&setup=true&lang=js"

import "./InstallPage.vue?vue&type=style&index=0&id=5bf948b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bf948b9"]])

export default __exports__